import $ from 'jquery';
import layout from '../Layout';
import ProductImages from './ProductImages';
import ProductForm from './ProductForm';

export default class ProductDetails {
  constructor($el, section) {
    this.data = section.data;
    this.onboarding = this.data.onboarding;

    this.$el = $el;
    this.$window = $(window);
    this.$productImages = $('[data-product-images]', $el);
    this.$productImageItems = $('[data-product-image]', $el);
    this.productImagesCount = this.$productImageItems.length;
    this.$productDetails = $('[data-product-details]', $el);
    this.$menu = $('[data-product-menu-container]', $el);

    this.positionDetails = this._positionDetails.bind(this);

    // Alert
    this.$alert = $('.product-alert', $el);

    this.productImages = new ProductImages(this.$el[0], {
      images_layout: section.data.images_layout,
      navigateToImages: false,
    });

    $(window).on('product-variant-switch', (event, data) => this._onVariantChange(data.variant));

    // Form
    if (!this.onboarding && this.data.form_is_inline) {
      this.form = new ProductForm(this.$el.find('[data-product-details]'), {
        form: $('[data-product-form-inline]', this.$el),
        product: this.data.product,
        moneyFormat: this.data.money_format,
        postMessage: section.postMessage,
        useHistory: this.data.use_history,
        enableCartRedirection: this.data.enable_cart_redirection,
        onAddToCart: () => this._hideAlert(),
        onSuccess: (response, quantity) => this._onAtcSuccess(response, quantity),
        onError: (response, error) => this._onAtcError(response, error),
      });

      $(window).trigger('product-variant-switch', { variant: this.form.variantHelper.getSelectedVariant() });
    }

    // Handle layout changes
    this.onLayoutChange = () => this._layout();
    layout.onBreakpointChange(this.onLayoutChange);

    // Initial positioning
    this._layout();

    // Events
    this.events = [
      // Dismiss alert
      this.$alert
        .find('.product-alert-dismiss')
        .on('click.product', () => this._hideAlert()),
    ];
  }

  selectImageByVariant(variant) {
    this.productImages.selectImageByVariant(variant);
  }

  unload() {
    this.$window.off('.product-details');
    layout.offBreakpointChange(this.onLayoutChange);
    this._hideAlert();

    if (this.form) this.form.unload();

    this.productImages.unload();
  }

  _layout() {
    if (layout.isBreakpoint('L')) {
      this.$window.on('resize.product-details', this.positionDetails);
    } else {
      this.$window.off('resize.product-details');
    }

    this._positionDetails();
  }

  _positionDetails() {
    let isSticky = false;

    if (layout.isBreakpoint('L')) {
      const imagesHeight = this.$productImages.outerHeight();
      const detailsHeight = this.$productDetails.outerHeight();
      const windowHeight = window.innerHeight;
      const menuHeight = this.$menu.outerHeight() || 0;
      const availableHeight = windowHeight - menuHeight;

      isSticky = (
        imagesHeight > availableHeight
        && detailsHeight < availableHeight
      );
    }

    this.productImages.setOptions({ navigateToImages: isSticky });
    this.$productDetails.toggleClass('product-details-sticky', isSticky);
  }

  _onAtcSuccess() {
    this._showAlert(this.data.text.added_to_cart_link);
  }

  _onAtcError(response, error) {
    this._showAlert(error, 'error');
  }

  _onVariantChange(variant) {
    this.productImages.selectImageByVariant(variant);
    this.$el.find('.product-form-inline-atc-button')
      .prop('disabled', !variant.available)
      .text(variant.available
        ? this.data.text.product_available
        : this.data.text.product_unavailable,
      );
  }

  _showAlert(message, type = null) {
    this._hideAlert();

    // Add class name
    if (type) {
      this.alertClassName = `product-alert-${type}`;
      this.$alert.addClass(this.alertClassName);
    }

    // Set text
    const $message = this.$alert.find('.product-alert-message');
    $message.html(message);
    this.$alert.one('revealer-hide', event => $message.text(''));

    // Show
    this.$alert.revealer('show');

    // Positioning
    this._positionAlert();
    $(window).on('scroll.product-alert', event => this._positionAlert());
  }

  _hideAlert() {
    // Remove custom class names
    this.$alert.removeClass(this.alertClassName);
    this.alertClassName = null;

    // Stop positioning
    $(window).off('scroll.product-alert');

    // Hide
    this.$alert.revealer('hide');
  }

  _positionAlert() {
    const top = this.$el.offset().top;
    const scroll = document.body.scrollTop;
    this.$alert.toggleClass('product-alert-fixed', scroll >= top);
  }
}
